import { CopyAll } from "@mui/icons-material";
import { Autocomplete, capitalize, Grid } from "@mui/material";
import { CopyableId } from "components/alove/CopyableId";
import { DropdownButton } from "components/alove/DropDownButton";
import { ImageUploader } from "components/alove/ImageUploader";
import { addAlert, useMaterialUIController } from "context";
import { Content, ContentType } from "models/content/Content";
import { useParams } from "react-router-dom";
import React, { useMemo } from "react";
import EmbeddedLinkPreview, { isEmbeddableLink } from "components/alove/EmbeddedLinkPreview";
import OGTagsPreview from "components/alove/OGTagsPreview";

const MDInput = require("components/MDInput/index.js").default;


export const ContentLink = ({
  content,
  setContent,
}: {
  content: Content;
  setContent: (content) => void;
}) => {
  const [controller, dispatch] = useMaterialUIController();
    const { id,type } = useParams();
  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        {(content.type === ContentType.link || content.type === ContentType.article) && (
          <>
            <MDInput
              label="Link"
              fullWidth
              value={content.link}
              onChange={(e) => setContent({ ...content, link: e.target.value })}
              required
            />
            {/* Link Preview */}
            {content.link && (
              isEmbeddableLink(content.link) ? (
                <EmbeddedLinkPreview link={content.link} />
              ) : (
                <OGTagsPreview link={content.link} />
              )
            )}
          </>
        )}

        {content.type === ContentType.image && (
          <ImageUploader
            folder="contentCenter"
            count={1}
            initImage={[content.link]}
            onUploaded={(url) => setContent({ ...content, link: url[0] })}
          />
        )}

        {content.type === ContentType.video && (
          <Grid container flexDirection="column" spacing={2}>
            <Grid>
              <ImageUploader
                folder="contentCenter"
                count={1}
                fileType="video/*"
                initImage={[content.link]}
                buttonOnly
                buttonTitle="Upload Video"
                onUploaded={(url) => setContent({ ...content, link: url[0] })}
              />
            </Grid>
            {content.link && (
              <Grid>
                <video width="350" height="350" controls>
                  <source src={content.link} type="video/mp4" />
                </video>
              </Grid>
            )}
          </Grid>
        )}

        {content.type === ContentType.audio && (
          <Grid container flexDirection="column" spacing={2}>
            <Grid>
              <ImageUploader
                folder="contentCenter"
                count={1}
                fileType="audio/*"
                initImage={[content.link]}
                buttonOnly
                buttonTitle="Upload Audio"
                onUploaded={(url) => setContent({ ...content, link: url[0] })}
              />
            </Grid>
            {content.link && (
              <Grid>
                <audio controls>
                  <source src={content.link} type="audio/mpeg" />
                </audio>
              </Grid>
            )}
          </Grid>
        )}

       
      </Grid>
    </Grid>
  );
};
